import { render, staticRenderFns } from "./VendorSingleSelect.vue?vue&type=template&id=5c0958fc&"
import script from "./VendorSingleSelect.vue?vue&type=script&lang=js&"
export * from "./VendorSingleSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VContainer})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src806641569/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c0958fc')) {
      api.createRecord('5c0958fc', component.options)
    } else {
      api.reload('5c0958fc', component.options)
    }
    module.hot.accept("./VendorSingleSelect.vue?vue&type=template&id=5c0958fc&", function () {
      api.rerender('5c0958fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VendorSingleSelect.vue"
export default component.exports